import { makeAxiosClient } from './secondStepClient'

export const makeSharedEndpoints = _api => {
  return {
    // Only methods that still route to v3 remain here
    postAcceptUserAgreement: async documentId => {
      const body = {
        documentId,
      }
      return _api.post(`useragreement/me`, body)
    },
  }
}

export const buildClient = ({ baseApiAddress, extend }) => {
  const _api = makeAxiosClient(baseApiAddress)
  const shared = makeSharedEndpoints(_api)
  const extended = typeof extend === 'function' ? extend(shared, _api) : shared
  return { baseApiAddress, ...extended }
}
